module.exports = __webpack_public_path__ + "static/media/help-support-banner-nick.af1912ba.png";